import { atom } from "recoil";

export const DistrictQNState = atom({
  key: "DistrictQNState",
  default: [],
});
